// Function to adjust the slider width based on sidebar visibility
function adjustSliderWidth() {
  const carousel = document.querySelector(".video-carousel");
  const sidebar = document.getElementById("sidebar-group");

  // Check if the sidebar is visible (you can replace the condition with your custom logic)
  if (sidebar.classList.contains("visible")) {
    // Sidebar is visible, set slider width to 80%
    carousel.style.width = "80%";
  } else {
    // Sidebar is hidden, set slider width to 100%
    carousel.style.width = "100%";
  }

  // Re-initialize carousel to adjust layout after width change
  setTimeout(() => {
    initializeVideoCarousel(); // Reinitialize carousel to adjust layout
  }, 300); // Adjust the timeout based on your sidebar transition duration
}

// Initialize carousel on DOM ready
document.addEventListener("DOMContentLoaded", () => {
  initializeVideoCarousel();
  adjustSliderWidth(); // Adjust slider width when the page loads
});

// Re-run slider logic when the sidebar visibility changes (you'll need to trigger this event yourself)
document.addEventListener("sidebar:visibilityChanged", () => {
  adjustSliderWidth(); // Adjust width when sidebar visibility changes
});

// Slider initialization function
function initializeVideoCarousel() {
  const carousels = document.querySelectorAll(".video-carousel");

 carousels.forEach((carousel) => {



    const autoplay = carousel.dataset.autoplay === "true";
    const autoplaySpeed = parseInt(carousel.dataset.autoplaySpeed) || 5000;
    let previous = 0;

    // Add fallback hiding until initialized
    carousel.classList.remove("keen-slider-initialized");
    carousel.style.visibility = "hidden";
    carousel.style.height = "0";

const slider = new KeenSlider(carousel, {
  loop: true,
  mode: "snap",
  slides: {
    origin: "center",
    perView: 3,
    spacing: 16,
  },
  breakpoints: {
    "(max-width: 768px)": {
      slides: {
        origin: "center",
        perView: 1.5,
        spacing: 12,
      },
    },
  },

  created() {
    carousel.classList.add("keen-slider-initialized");
    carousel.style.visibility = "visible";
    carousel.style.height = "auto";
     },

  slideChanged(s) {
    const current = s.track.details.rel;
    const slides = s.slides;
    slides.forEach((slide) =>
      slide.classList.remove("slide-animate", "looped-start")
    );
    void slides[current].offsetWidth;
    slides[current].classList.add("slide-animate");
  },

  move(s) {
    const current = s.track.details.rel;
    if (previous > current) {
      const loopedSlide = s.slides[current];
      loopedSlide.classList.remove("looped-start");
      void loopedSlide.offsetWidth;
      loopedSlide.classList.add("looped-start");
    }
    previous = current;
  },
});

    // Prev/Next controls
    const prevBtn = carousel.querySelector(".prev-button");
    const nextBtn = carousel.querySelector(".next-button");

    prevBtn?.addEventListener("click", () => slider.prev());
    nextBtn?.addEventListener("click", () => slider.next());

    // Dot navigation
    const dotContainer = carousel.nextElementSibling;
    if (dotContainer?.classList.contains("carousel-dots")) {
      // Remove existing dots before adding new ones
      dotContainer.innerHTML = "";

      for (let i = 0; i < slider.track.details.slides.length; i++) {
        const dot = document.createElement("button");
        dot.classList.add("dot");
        dot.setAttribute("aria-label", `Go to slide ${i + 1}`);
        dot.addEventListener("click", () => slider.moveToIdx(i));
        dotContainer.appendChild(dot);
      }

      const updateDots = () => {
        const active = slider.track.details.rel;
        dotContainer
          .querySelectorAll(".dot")
          .forEach((dot, idx) => dot.classList.toggle("active", idx === active));
      };

      slider.on("slideChanged", updateDots);
      updateDots();
    }


if (autoplay) {
  let autoplayTimeout;

  const autoPlayFn = () => {
    clearTimeout(autoplayTimeout);
    autoplayTimeout = setTimeout(() => {
      slider.next();
      autoPlayFn();
    }, autoplaySpeed);
  };

  slider.on("created", () => {
    autoPlayFn();
  });
}
  });
}

// Video modal logic
const modal = document.getElementById("videoModal");
const iframe = document.getElementById("videoIframe");
const videoCards = document.querySelectorAll(".video-thumb");

videoCards.forEach((card) => {
  card.addEventListener("click", () => {
    const videoId = card.getAttribute("data-video-id");
    iframe.src = `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0&modestbranding=1`;
    modal.style.display = "flex";
  });
});

document.getElementById("closeModal")?.addEventListener("click", () => {
  modal.style.display = "none";
  iframe.src = "";
});

window.addEventListener("click", (event) => {
  if (event.target === modal) {
    modal.style.display = "none";
    iframe.src = "";
  }
});